// store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import branchReducer from './slices/branchSlice'
import productReducer from './slices/productSlice'
import tagsReducer from './slices/tagsSlice'
import customerReducer from './slices/customerSlice'
import partnerReducer from './slices/partnerSlice'
import groupCodeReducer from './slices/groupCodeSlice'
import solicitorReducer from './slices/solicitorsSlice'

export default configureStore({
  reducer: {
    user: userReducer,
    branch:branchReducer,
    product:productReducer,
    tag:tagsReducer,
    customer:customerReducer,
    partner:partnerReducer,
    groupCode:groupCodeReducer,
    solicitor:solicitorReducer
  },
});